import Vue from 'vue'

export async function fetchAdvancePayments({
  commit
}) {
  try {
    const {
      data
    } = await Vue.axios({
      url: '/frontend/advance_payments'
    })
    commit("setAdvancePayments", data);
    return data
  } catch (error) {
  } finally {
    // console.log('la peticion de cumpleaños de los usuarios ha finalizado')
  }
}
export async function createAdvancePayment({ commit }, payload) {
  try {
    const { data } = await Vue.axios({
      method: "POST",
      url: `/frontend/advance_payments`,
      data: payload
    })

    return data
  } catch (e) {
    return false
  } 
  finally {}
}
export async function fetchCompanies({
  commit
}) {
  try {
    const {
      data
    } = await Vue.axios({
      url: '/frontend/advance_payments/companies'
    })
    commit("setCompanies", data);
    return data
  } catch (error) {
  } finally {
  }
}
export async function fetchCurrentPeriod({
  commit
}) {
  try {
    const {
      data
    } = await Vue.axios({
      url: '/frontend/advance_payments/current_period'
    })
    return data
  } catch (error) {
  } finally {
  }
}
export async function updateAdvancePayment({ commit }, payload) {
  try {
    const { data } = await Vue.axios({
      method: "PUT",
      url: `/frontend/advance_payments/${payload}`,
      data: payload
    })
    return data
  } catch (e) {
    return false
  } 
  finally {}
}
